import $ from 'jquery';
import './foundation.js';
import { responsiveEmbeds } from './responsive-embeds';
import { homeSlider } from './home-slider.js';
import { sidebarToggle } from './sidebar-toggle.js';
import { disclaimer } from './disclaimer.js';
import { disclaimerSticky } from './disclaimer-sticky.js';
import { animation } from './animation.js';
import { singleBusinesses } from './single-businesses.js';
import { archiveBusinesses } from './archive-businesses.js';
import { anchorNavToggle } from './anchor-nav-toggle.js';
import { formTwoCol } from './form-two-col.js';
import { mobileMenu } from './mobile-menu';
import { autoAria } from './auto-aria.js';

$(document).ready(function() {
	$(document).foundation();
	
	checkIE();
	responsiveEmbeds();
	homeSlider();
	sidebarToggle();
	disclaimer();
	disclaimerSticky();
	singleBusinesses();
	anchorNavToggle();
	formTwoCol();
	mobileMenu();
	autoAria();
});

$(window).load(function() {
	animation();
	archiveBusinesses();
})

$('html').removeClass('no-js')	
				 .addClass('js');

function isIE() {
	// IE 10 and IE 11
	return /Trident\/|MSIE/.test(window.navigator.userAgent);
}

function checkIE() {
	if( isIE() ) {
		$('html').addClass('ie');
	}
}